'use client'

import { useEffect } from 'react'
import { ErrorBoundary } from '@/components/ErrorBoundary'
import { ThemeProvider } from '@/components/ThemeProvider'

// Lightweight provider shell for all pages (including marketing).
// AppProviders adds the heavier app-only layers (QueryProvider, MotionConfig, InstallBanner, etc.)
// inside the (app) route group — keeping motion/react out of the marketing bundle.
export function MinimalProviders({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch((err) => {
        console.warn('[SW] Registration failed:', err)
      })
    }
  }, [])

  return (
    <ThemeProvider>
      <ErrorBoundary>
        {children}
      </ErrorBoundary>
    </ThemeProvider>
  )
}
